/**
 * Coverage-notification enum and config shape. Kept in a component-free file so services (e.g.
 * CoverageNotificationService) can reference the enum without importing the banner component, which
 * would otherwise pull the account-edit component graph into every consumer's build.
 */
export enum CoverageNotificationType {
  EXPIRED = 'expired',
  NO_ACTIVE_COVERAGE = 'no_active_coverage',
  COVERAGE_UNVERIFIED = 'coverage_unverified',
  NO_COVERAGE = 'no_coverage',
  EAP_SESSIONS_LOW = 'eap_sessions_low',
  EAP_SESSIONS_OUT_OF = 'eap_sessions_out_of',
  EAP_EXPIRING_SOON = 'eap_expiring_soon',
  EAP_EXPIRED = 'eap_expired',
  OUT_OF_NETWORK = 'out_of_network',
  ADD_PAYMENT_METHOD = 'add_payment_method'
}

export interface ICoverageNotificationConfig {
  title: string;
  subtitle: string;
  actionText?: string;
  iconName: string;
  actionLinkClick?: () => void;
  linkClick?: () => void;
  link?: string;
}
